import ServiceCard from '@/components/elements/Card/ServiceCard';
import { Fab, LinkButton } from '@/components/elements/forms/buttons';
import { ListItem } from '@/components/elements/lists';
import Icon from '@/components/icons/Icon';
import { hasFeatureSetting, trackMpEvent } from '@/helpers';
import { getGiftcardCheckoutLink, getGiftcardLabel } from '@/helpers/placeHelperTS';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';
import { Place } from '@/types/state/shared';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

function trackGiftcardClick(placeId: number) {
  trackMpEvent('buy_gift_card_clicked', {
    screen_name: 'company_details',
    company_id: placeId,
    trigger_source: 'company_details',
  });
}

const baseTranslationKey = 'features.PlacePages.modules.Giftcards';

const Giftcards = ({ place }: { place: Place }) => {
  const history = useHistory();
  const { isMobileView } = useMobileView();
  const hasCollapsedSetting = hasFeatureSetting(place, 'collapsed_services');
  const [expanded, setExpanded] = useState<boolean>(isMobileView ? false : !hasCollapsedSetting);

  const giftcardLabel = getGiftcardLabel(place);
  const giftcardLink = getGiftcardCheckoutLink(place);

  const handleRowGiftcardClick = () => {
    trackGiftcardClick(place.id);
    history.push({ pathname: getGiftcardCheckoutLink(place) });
  };

  const handleLinkGiftcardClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    trackGiftcardClick(place.id);
  };

  const handleToggleOpen = () => setExpanded((prev) => !prev);

  return (
    <section>
      <ListItem
        leftPadding={false}
        type="div"
        leftSlot={<Icon variant="gift" size="md" />}
        underline={!expanded}
        rightSlot={
          <Fab
            size="sm"
            variant="secondary"
            aria-label={_s(`${baseTranslationKey}.toggle.aria-label.${expanded ? 'close' : 'open'}`)}
            onClick={handleToggleOpen}
            rightIcon={<Icon variant={expanded ? 'chevron-up' : 'chevron-down'} color="fg_primary" />}
          />
        }>
        <h2 className="text-h-m">{_s('GiftCard')}</h2>
      </ListItem>
      {expanded && (
        <div className="gap-sm pb-xl border-border_regular flex flex-col border-b">
          <ServiceCard
            name={giftcardLabel}
            icon="gift-card"
            description={_s(`${baseTranslationKey}.card-description`)}
            price={{ type: 'optional', value: [0] }}
            onRowClick={handleRowGiftcardClick}
            rightSlot={
              <LinkButton
                to={giftcardLink}
                onClick={handleLinkGiftcardClick}
                variant="primary"
                size={isMobileView ? 'md' : 'sm'}
                className="flex max-w-[75px] items-center">
                {isMobileView ? _s('Buy') : _s('BuyNow')}
              </LinkButton>
            }
          />
        </div>
      )}
    </section>
  );
};

export default Giftcards;
